// AssetCatalog.js - 资源 key → 路径索引（供按需加载使用）
import PreloaderResourceList from './Preloader/PreloaderResourceList.js';

let mapTileCatalog = null;
let battleImageCatalog = null;

function ensureCatalogs() {
    if (mapTileCatalog && battleImageCatalog) {
        return;
    }

    const list = new PreloaderResourceList();
    mapTileCatalog = Object.fromEntries(
        list.generateMapTileResources().map(({ key, path }) => [key, path])
    );
    battleImageCatalog = Object.fromEntries(
        list.generateBattleResources().map(({ key, path }) => [key, path])
    );
}

/**
 * @param {string} key
 * @returns {string|undefined}
 */
export function getMapTilePath(key) {
    ensureCatalogs();
    return mapTileCatalog[key];
}

/**
 * @param {string} key
 * @returns {string|undefined}
 */
export function getBattleImagePath(key) {
    ensureCatalogs();
    return battleImageCatalog[key];
}

/**
 * @param {Iterable<string>} keys
 * @returns {Array<{ key: string, path: string }>}
 */
export function resolveBattleImageResources(keys) {
    ensureCatalogs();
    const resources = [];

    for (const key of keys) {
        if (!key) continue;
        const path = battleImageCatalog[key];
        if (path) {
            resources.push({ key, path });
        }
    }

    return resources;
}

/**
 * @param {Iterable<string>} keys
 * @returns {Array<{ key: string, path: string }>}
 */
export function resolveMapTileResources(keys) {
    ensureCatalogs();
    const resources = [];

    for (const key of keys) {
        if (!key) continue;
        const path = mapTileCatalog[key];
        if (path) {
            resources.push({ key, path });
        }
    }

    return resources;
}
